import {
  VALIDATE_USER_CREDENTIAL,
  VALIDATION_FAILURE
} from "../reducerConstants";
import * as API from "../../utils/api";
import { makeApiCall } from "../../utils/customUtils";

const ValidateURLCollection = new Map([
  ['v1', 'api/v1/Authentication'],
  ['v2', 'api/v1/Authentication/HCPAppAccessToken'],
]);

const ValidateURLVersion = 'v2';

export const Validate = (username, pass) => {
  return async (dispatch) => {
    const formData = new FormData();
    formData.append('userName', username);
    formData.append('password', pass);

    const url = ValidateURLCollection.get(ValidateURLVersion);
    const api = API.post(url, { data: formData, headers: { 'api-key': 'YWRtaW4ta2V5' } }, dispatch, undefined, true, false);
    return await makeApiCall(dispatch, api, VALIDATE_USER_CREDENTIAL, VALIDATION_FAILURE);
  };
};
